import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../services/api';

const NotificationContext = createContext();

export const NotificationProvider = ({ children, user }) => {
    const [unreadCount, setUnreadCount] = useState(0);
    const [unreadMessages, setUnreadMessages] = useState(0);

    const fetchCounts = useCallback(async () => {
        const token = localStorage.getItem('token');
        if (!token) {
            setUnreadCount(0);
            setUnreadMessages(0);
            return;
        }

        try {
            const [notifRes, msgRes] = await Promise.all([
                api.get('/users/me/notifications'),
                api.get('/messages/unread/count')
            ]);

            if (Array.isArray(notifRes.data)) {
                setUnreadCount(notifRes.data.filter(n => !n.is_read).length);
            }
            if (msgRes.data && typeof msgRes.data.count === 'number') {
                setUnreadMessages(msgRes.data.count);
            }
        } catch (err) {
            console.error('Failed to fetch unread counts:', err);
        }
    }, []);

    useEffect(() => {
        if (user) {
            fetchCounts();
        } else {
            setUnreadCount(0);
            setUnreadMessages(0);
        }
    }, [user, fetchCounts]);

    useEffect(() => {
        if (!user) return;
        const interval = setInterval(fetchCounts, 30000);
        return () => clearInterval(interval);
    }, [user, fetchCounts]);

    return (
        <NotificationContext.Provider value={{
            unreadCount,
            unreadMessages,
            setUnreadCount,
            setUnreadMessages,
            refreshCounts: fetchCounts
        }}>
            {children}
        </NotificationContext.Provider>
    );
};

export const useNotifications = () => {
    const context = useContext(NotificationContext);
    if (!context) {
        throw new Error('useNotifications must be used within a NotificationProvider');
    }
    return context;
};
